import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Event, EventsService } from '../../core/services/events.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-event-card',
  imports: [CommonModule],
  templateUrl: './event-card.html',
  styleUrl: './event-card.css',
})
export class EventCard {
  @Input() event?: Event;

  constructor(
    private router: Router,
    private eventsService: EventsService
  ) {}

  getEventImage(): string {
    if (!this.event) return this.eventsService.getDefaultImage('cuadrada');
    return this.eventsService.getEventImage(this.event, 'cuadrada');
  }

  navigateToEvent(): void {
    if (this.event) {
      this.router.navigate(['/evento', this.event.url_slug]);
    }
  }

  formatDate(dateString: string): string {
    if (!this.event) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric',
      timeZone: this.event.timezone || 'America/Guayaquil'
    });
  }

  formatTime(dateString: string): string {
    if (!this.event) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString('es-ES', { 
      hour: '2-digit', 
      minute: '2-digit',
      timeZone: this.event.timezone || 'America/Guayaquil'
    });
  }
}
